import { useState, useCallback, useMemo } from 'react';
import { FeeScheduleView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for managing fee schedule search and filtering
 */
export function useFeeScheduleSearch(feeSchedules: FeeScheduleView[]) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredFeeSchedules = useMemo(() => {
    if (!searchTerm.trim()) {
      return feeSchedules;
    }

    const searchLower = searchTerm.toLowerCase().trim();
    return feeSchedules.filter(
      (schedule) =>
        schedule.description?.toLowerCase().includes(searchLower) ||
        schedule.category?.toLowerCase().includes(searchLower) ||
        schedule.feeType?.toLowerCase().includes(searchLower)
    );
  }, [feeSchedules, searchTerm]);

  const handleSearchChange = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  return {
    searchTerm,
    filteredFeeSchedules,
    handleSearchChange,
    handleClearSearch,
  };
}
